<template>
  <div class="createOpenClass">
    <div class="section">
      <el-page-header @back="goBack" content="新增正式班"> </el-page-header>

      <div class="classinfo">
        <el-form
          size="mini"
          label-width="100px"
          :model="form"
          :rules="rules"
          ref="form"
        >
          <el-form-item label="目标校区" required>
            <el-select
              v-model="form.educational_institution_campus_id"
              @change="getCampusSubjectList"
            >
              <el-option
                v-for="(item, index) of schoolList"
                :key="index"
                :label="item.campusName"
                :value="item.dept_id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="授课类型" required prop="teaching_type">
            <el-select
              v-model="form.teaching_type"
              @change="getCampusCurriculumtList"
            >
              <el-option label="面授课" :value="1"></el-option>
              <!--
              <el-option label="直播课" :value="2"></el-option>
              <el-option label="录播课" :value="3"></el-option>
              -->
            </el-select>
          </el-form-item>

          <el-form-item label="学科" required prop="subject_id">
            <el-select
              :disabled="form.teaching_type === ''"
              v-model="form.subject_id"
              @change="getCampusCurriculumtList"
            >
              <el-option
                :label="item.name"
                :value="item.id"
                v-for="(item, index) of subjectList"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="课程体系" required prop="curriculum_id">
            <el-select
              filterable
              v-model="form.curriculum_id"
              @change="getCampusTeacherList"
              :disabled="!form.subject_id"
            >
              <el-option
                :label="item.title"
                :value="item.id"
                v-for="(item, index) of curriculum_list"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="上课老师" required prop="lecturer_id">
            <el-select v-model="form.lecturer_id" filterable>
              <el-option
                :label="item.realName + ' ' + '(' + item.name + ')'"
                :value="item.id"
                v-for="(item, index) of teacherList"
                :key="index"
              ></el-option>
            </el-select>

            <el-tooltip
              class="item"
              effect="dark"
              content="1、具有老师角色的账号,可以成为上课老师; 2、上课老师有对应的课程权限,才可以分配到班级;"
              placement="top"
              v-if="show_user"
            >
              <el-link
                style="margin-left: 10px"
                type="primary"
                @click="GoUserSet"
                >添加老师</el-link
              >
            </el-tooltip>
            <i v-if="show_user" class="el-icon-question"></i>
          </el-form-item>
          <!--
          <el-form-item label="助教老师">
            <el-select v-model="form.assistant_teacher_id" clearable>
              <el-option
                :label="item.realname + ' ' + '(' + item.name + ')'"
                :value="item.id"
                v-for="(item, index) of teacherListTo"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          -->
          <el-form-item label="班级名称" required prop="name">
            <el-input
              v-model="form.name"
              placeholder="请输入班级名称"
              style="width: 170px"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="addClass('form')"
              >创建班级</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getCurriculumList,
  getClassInfo,
  addClasses,
  getUserCampusList,
  getCampusSubjectList,
  getCampusCurriculumtList,
  // getCampusTeacherList,
} from '@/api/educational'
import { api_eduCampusSelectTchListByCampus } from '@/api/javaApi'
import { getUserSubjectList } from '@/api/user'
export default {
  name: 'create-class',
  data() {
    return {
      form: {
        name: '',
        subject_id: '',
        curriculum_id: '',
        educational_institution_campus_id: '',
        curriculum_class_type: '1',
        teaching_type: 1,
        lecturer_id: '',
        assistant_teacher_id: '',
        present_price: '',
        original_price: '',
      },
      status: '',
      resource: '',
      schoolList: [],
      subjectList: [],
      curriculum_list: [],
      teacherList: [],
      teacherListTo: [],
      rules: {
        curriculum_id: [
          {
            required: true,
            message: '请选择课程',
            trigger: 'change',
          },
        ],
        name: [
          {
            required: true,
            message: '请输入班级名称',
            trigger: 'blur',
          },
          {
            required: true,
            message: '请输入班级名称',
            trigger: 'change',
          },
        ],
        teaching_type: [
          { required: true, message: '请选择课程类型', trigger: 'change' },
        ],
        lecturer_id: [
          { required: true, message: '请选择主讲老师', trigger: 'change' },
        ],
        educational_institution_campus_id: [
          { required: true, message: '请选择校区', trigger: 'change' },
        ],
        sort_num: [
          { required: true, message: '请输入排序号', trigger: 'change' },
        ],
        subject_id: [
          { required: true, message: '请选择学科', trigger: 'change' },
        ],
      },

      is_principal: false,
      show_user: false,
    }
  },
  mounted() {
    this.getUserCampusList()
  },
  methods: {
    //创建班级
    addClasses() {
      addClasses({
        name: this.form.name,
        subject_id: this.form.subject_id,
        curriculum_id: this.form.curriculum_id,
        educational_institution_campus_id: this.form
          .educational_institution_campus_id,
        curriculum_class_type: this.form.curriculum_class_type,
        teaching_type: this.form.teaching_type,
        lecturer_id: this.form.lecturer_id,
        assistant_teacher_id: this.form.assistant_teacher_id,
      }).then((res) => {
        console.log('创建正式班级')
        console.log(res)
        if (res.is_create) {
          this.$message.success('创建正式班成功')
          this.$router.push({
            name: 'class-management',
          })
        }
      })
    },

    getClassInfo() {
      getClassInfo({
        class_code: this.$route.query.class_code,
      }).then((res) => {
        this.form.educational_institution_campus_id =
          res.class_obj.educational_institution_campus_id
        this.form.name = res.class_obj.name
        this.form.teaching_type = res.class_obj.teaching_type
        this.form.subject_id = res.class_obj.subject_id
        this.form.curriculum_id = res.class_obj.curriculum_id
        this.form.lecturer_id = res.class_obj.lecturer_id
        this.form.assistant_teacher_id = res.class_obj.assistant_teacher_id
        this.getCurriculumList()
        this.getCampusCurriculumtList()
      })
    },
    // 创建教师
    addClass(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.form)
          this.addClasses()
        }
      })
    },
    handleFocusCurriculum() {
      if (!this.form.subject_id || !this.form.teaching_type) {
        this.$message.warning('请先选择类型和学科')
        return
      }
    },
    // 获取校区
    getUserCampusList() {
      getUserCampusList().then((res) => {
        this.schoolList = res.userDeptList
        this.form.educational_institution_campus_id = this.schoolList[0].dept_id
        this.getCampusSubjectList()
      })
    },

    //获取学校科目权限列表
    getCampusSubjectList() {
      console.log('校区ID')
      console.log(this.form)
      getCampusSubjectList({
        campusId: this.form.educational_institution_campus_id,
      }).then((res) => {
        this.subjectList = res.campusSubjectList
        console.log('获取学校科目权限列表')
        console.log(res)
      })
    },

    // 获取学科
    getUserSubjectList() {
      getUserSubjectList().then((res) => {
        this.subjectList = res.base_platform.concat(res.mechanism_platform)

        console.log('获取学科')
        console.log(res)
      })
    },

    //获取学校公开课课程体系
    getCampusCurriculumtList() {
      console.log('this.form.subject_id')
      console.log(this.form.subject_id)

      this.curriculum_list = []
      this.form.curriculum_id = ''

      if (!this.form.subject_id) {
        console.log('请选择科目')
        return
      }
      getCampusCurriculumtList({
        campusId: this.form.educational_institution_campus_id,
        subjectId: this.form.subject_id,
        teaching_type: this.form.teaching_type,
        class_type: '',
      }).then((res) => {
        console.log('获取学校科目下全部课程')
        console.log(res)
        this.curriculum_list = res.campusCurriculumList
      })
    },

    // 获取课程体系
    getCurriculumList(status) {
      if (status === 'change') {
        this.form.curriculum_id = ''
      }
      getCurriculumList({
        subject_id: this.form.subject_id,
        teaching_type: this.form.teaching_type,
        page_no: 1,
        page_size: 100,
      }).then((res) => {
        this.curriculum_list = res.curriculum_list
      })
    },

    // 具有科目权限及课程体系的老师
    getCampusTeacherList() {
      api_eduCampusSelectTchListByCampus({
        eduCampusIdList: [this.form.educational_institution_campus_id],
        subjectId: this.form.subject_id,
        curriculumId: this.form.curriculum_id,
      }).then((res) => {
        console.log('具有科目权限及课程体系的老师')
        console.log(res)
        this.teacherList = res //主讲老师
        this.teacherListTo = res //助教老师

        if (this.teacherList.length == 0) {
          //权限控制
          this.is_principal = this.$store.getters.is_principal

          if (this.is_principal) {
            console.log('校区管理员')
            this.show_user = true
          }
        }
      })
    },

    GoUserSet() {
      this.$router.push({
        name: 'school-user-list',
      })
    },

    goBack() {
      this.$router.push({
        name: 'class-management',
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.createOpenClass {
  .section {
    box-sizing: border-box;
    margin: 10px;
    padding: 20px;
    background-color: #fff;
    border-radius: 5px;

    .title {
      font-size: 16px;
    }
    .classinfo {
      margin-top: 15px;
    }

    h2 {
      font-size: 24px;
      font-weight: bold;
      color: #67c23a;
      margin-bottom: 10px;
    }
    ul {
    }
    li {
      list-style: square;
      line-height: 40px;
      font-size: 16px;
    }
    .btn {
      margin-top: 20px;
      font-size: 16px;
    }
  }
}
</style>
